import { render, staticRenderFns } from "./system-emails-translations-tab.vue?vue&type=template&id=65b94889"
import script from "./system-emails-translations-tab.vue?vue&type=script&lang=js"
export * from "./system-emails-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports